import React, { useState, useRef } from 'react';
import { adminApi } from '../../api';
import { useApi } from '../../hooks/useApi';
import { uploadImg } from '../../utils/media';
import { Spinner, EmptyState } from '../../components/StateHelpers';
import { useToast } from '../../hooks/use-toast';
import { UploadCloud, Trash2, Image as ImageIcon, Copy } from 'lucide-react';

export default function AdminMedia() {
  const { data, loading, refresh } = useApi(() => adminApi.uploads(), []);
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef();
  const { toast } = useToast();

  const onUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    try {
      for (const f of files) await adminApi.upload(f);
      toast({ title: `${files.length} dosya yüklendi` });
      refresh();
    } catch (er) { toast({ title: 'Hata', description: 'Yükleme başarısız', variant: 'destructive' }); }
    finally { setUploading(false); e.target.value = ''; }
  };

  const remove = async (name) => {
    if (!window.confirm('Silmek istediğinize emin misiniz?')) return;
    await adminApi.deleteUpload(name);
    refresh();
  };

  const files = data || [];

  return (
    <div>
      <div className="flex items-center gap-4 mb-6">
        <div className="flex-1"><h1 className="font-display text-3xl font-black">Medya Kütüphanesi</h1><p className="text-white/50 text-sm">{files.length} dosya</p></div>
        <button onClick={() => inputRef.current?.click()} className="btn-gold h-10 px-4 rounded-lg inline-flex items-center gap-2 text-xs font-extrabold tracking-widest">
          <UploadCloud className="w-4 h-4" /> {uploading ? 'YÜKLENİYOR...' : 'DOSYA YÜKLE'}
        </button>
        <input ref={inputRef} type="file" multiple onChange={onUpload} accept="image/*,.pdf,.zip" className="hidden" />
      </div>

      {loading ? <Spinner /> : files.length === 0 ? <EmptyState icon={ImageIcon} title="Henüz dosya yok" subtitle="İlk dosyanızı yükleyin." /> : (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {files.map((f) => {
            const isImage = /\.(jpg|jpeg|png|webp|gif|svg)$/i.test(f.name);
            return (
              <div key={f.name} className="rounded-xl border border-white/8 bg-[#0d0d13] overflow-hidden group">
                <div className="aspect-square bg-[#0a090c] flex items-center justify-center overflow-hidden">
                  {isImage ? <img src={uploadImg(f.name)} alt={f.name} className="w-full h-full object-cover" /> : <ImageIcon className="w-8 h-8 text-white/30" />}
                </div>
                <div className="p-2">
                  <div className="text-[10px] text-white/60 truncate" title={f.name}>{f.name}</div>
                  <div className="flex gap-1 mt-1">
                    <button onClick={() => { navigator.clipboard.writeText(uploadImg(f.name)); toast({ title: 'URL kopyalandı' }); }} className="flex-1 h-7 rounded bg-white/5 hover:bg-[#e4b44e]/15 text-[10px] text-white/80 inline-flex items-center justify-center gap-1"><Copy className="w-3 h-3" /> URL</button>
                    <button onClick={() => remove(f.name)} className="w-7 h-7 rounded bg-white/5 hover:bg-red-500/15 text-red-300 inline-flex items-center justify-center"><Trash2 className="w-3 h-3" /></button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
